<div style="clear: both">
    <textarea style="display: inline-block" rows="20" cols="70" [(ngModel)]="text" (ngModelChange)="onTextChange()"></textarea>
    <pre style="display: inline-block; font-size: smaller">{{structure|json}}</pre>
</div>
